import { render } from "./Cert.vue?vue&type=template&id=b8b7dfb2&scoped=true&ts=true"
import script from "./Cert.vue?vue&type=script&lang=ts"
export * from "./Cert.vue?vue&type=script&lang=ts"

import "./Cert.vue?vue&type=style&index=0&id=b8b7dfb2&scoped=true&lang=scss"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b7dfb2"]])

export default __exports__